export default __webpack_public_path__ + "static/media/h5-bg5.1697e457.png";